import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequest
} from "@/helper/requests"
// import {executeRequest} from "@/store/modules/utils";

const state = {
  events: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    next: null,
    prev: null,
    detail: null,
    error: null,
    applications: {
      currentUrl: null,
      items: [],
      loading: false,
      count: 0,
      detail: null,
      error: null,

    }
  },
  applications: {
    // currentUrl: null,
    // items: [],
    loading: false,
    // count: 0,
    event_id: null,
    error: null,
    create: null,
  }
}

const getters = {
  getEvents: state => state.events.items,
  getEventsCount: state => state.events.count,
  getEventsCurrentUrl: state => state.events.currentUrl,
  getEventsNext: state => state.events.next,
  getEventsDetail: state => state.events.detail,
  isLoadingEvents: state => state.events.loading,
  isLoadingApplications: state => state.applications.loading,
  getApplicationsError: state => state.applications.error,
  getApplicationsResult: state => state.applications.create,
  saveEventsError: state => state.events.error,
}

const actions = {
  loadEvents: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {}, is_append }) => {
    if (!url) {
      url = mendeleev.USER.CALENDAR.EVENTS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingEvents) {
      commit('SET_EVENTS_LOADING')
      if (!is_append) {
        commit('CLEAN_EVENTS')
      }
      sendGetRequest(
        url, (data, url) => {
          commit('SET_EVENTS', [...getters.getEvents, ...data.results])
          commit('SET_EVENTS_COUNT', data.count + getters.getEventsCount)
          commit('SET_EVENTS_CURRENT_URL', url)
          commit('SET_EVENTS_NEXT_URL', data.next)
          commit('SET_EVENTS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_EVENTS_LOADING_END')
          commit('SAVE_EVENTS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadEventsDetail: ({ commit }, { url, id, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) url = url = mendeleev.USER.CALENDAR.EVENTS.DETAIL(id)
    sendGetRequest(
      url, (data, url) => {
        commit('SET_EVENTS_DETAIL', data)
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_EVENTS_ERROR', data)
        catcher(data, url)
      }
    )
  },
  singUpEvent: ({ commit }, { event_id, finalizer = () => {}, catcher = () => {} }) => {
    commit('SET_EVENT_APPLICATIONS_LOADING')
    const url = mendeleev.USER.CALENDAR.EVENTS.APPLICATIONS.CREATE(event_id)
    sendPostRequest(
      url, {}, (data, url) => {
        commit('SET_EVENT_APPLICATIONS_LOADING_END')
        commit('SAVE_EVENT_APPLICATIONS_CREATE', data)
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_EVENT_APPLICATIONS_ERROR', data)
        commit('SET_EVENT_APPLICATIONS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  cancelSingUpEvent: ({ commit }, { event_id, app_id, finalizer = () => {}, catcher = () => {} }) => {
    commit('SET_EVENT_APPLICATIONS_LOADING')
    const url = mendeleev.USER.CALENDAR.EVENTS.APPLICATIONS.CANCEL(event_id, app_id)
    sendPostRequest(
      url, {}, (data, url) => {
        commit('SET_EVENT_APPLICATIONS_LOADING_END')
        commit('SAVE_EVENT_APPLICATIONS_CREATE', data)
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_EVENT_APPLICATIONS_ERROR', data)
        commit('SET_EVENT_APPLICATIONS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  cleanSingUp: ({ commit }) => {
    commit('SAVE_EVENT_APPLICATIONS_CREATE', null)
    commit('SAVE_EVENT_APPLICATIONS_ERROR', null)
    commit('SET_EVENT_APPLICATIONS_LOADING_END')
  }

}

const mutations = {
  SET_EVENTS: (state, value) => {
    state.events.items = value
  },
  SET_EVENTS_DETAIL: (state, value) => {
    state.events.detail = value
  },
  SET_EVENTS_COUNT: (state, value) => {
    state.events.count = value
  },
  SET_EVENTS_CURRENT_URL: (state, value) => {
    state.events.currentUrl = value
  },
  SET_EVENTS_NEXT_URL: (state, value) => {
    state.events.next = value
  },
  SET_EVENTS_PREV_URL: (state, value) => {
    state.events.prev = value
  },
  SET_EVENTS_LOADING: (state) => {
    state.events.loading = true
  },
  SET_EVENTS_LOADING_END: (state) => {
    state.events.loading = false
  },
  SET_EVENT_APPLICATIONS_LOADING: (state) => {
    state.applications.loading = true
  },
  SET_EVENT_APPLICATIONS_LOADING_END: (state) => {
    state.applications.loading = false
  },
  SAVE_EVENTS_ERROR: (state, error) => {
    state.events.error = error
  },
  SAVE_EVENT_APPLICATIONS_ERROR: (state, error) => {
    state.applications.error = error
  },
  SAVE_EVENT_APPLICATIONS_CREATE: (state, data) => {
    state.applications.create = data
  },
  CLEAN_EVENTS: (state) => {
    state.events.count = 0
    state.events.next = null
    state.events.items = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
